"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC721ReceiverMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "enum ERC721ReceiverMock.Error",
    name: "error",
    type: "uint8"
  }],
  name: "setErrorType",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "0x608060405234801561001057600080fd5b5061031b806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063150b7a021461003b578063dafe3e3a1461006b575b600080fd5b61004e6100493660046101a9565b610080565b6040516001600160e01b0319909116815260200160405180910390f35b61007e610079366004610285565b610150565b005b6000600160005460ff16600381111561009b5761009b6102ad565b14156100ed5760405162461bcd60e51b815260206004820152601d60248201527f45524337323152656365697665724d6f636b3a20726576657274696e67000000604482015260640160405180910390fd5b600260005460ff166003811115610106576101066102ad565b141561011157600080fd5b600360005460ff16600381111561012a5761012a6102ad565b141561013f57600061013c81806102c3565b50505b50630a85bd0160e11b949350505050565b6000805482919060ff1916600183600381111561016f5761016f6102ad565b021790555050565b80356001600160a01b038116811461018e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b600080600080608085870312156101bf57600080fd5b6101c885610177565b93506101d660208601610177565b925060408501359150606085013567ffffffffffffffff808211156101fa57600080fd5b818701915087601f83011261020e57600080fd5b81358181111561022057610220610193565b604051601f8201601f19908116603f0116810190838211818310171561024857610248610193565b816040528281528a602084870101111561026157600080fd5b82602086016020830137600060208483010152809550505050505092959194509250565b60006020828403121561029757600080fd5b8135600481106102a657600080fd5b9392505050565b634e487b7160e01b600052602160045260246000fd5b6000826102e057634e487b7160e01b600052601260045260246000fd5b50049056fea2646970667358221220333c3802dfde7535dae6dbcc79dbf324dca4cfce78195277376e20290216325b64736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class ERC721ReceiverMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.ERC721ReceiverMock__factory = ERC721ReceiverMock__factory;

_defineProperty(ERC721ReceiverMock__factory, "bytecode", _bytecode);

_defineProperty(ERC721ReceiverMock__factory, "abi", _abi);